import { Grid, LinearProgress } from '@material-ui/core'
import PropTypes from 'prop-types'
import React, { useContext, useEffect, useState } from 'react'
import { FaTrashAlt } from 'react-icons/fa'
import Context from '../../context'
import history from '../../services/history'

import { getEventsList, getSearch, publishEvent } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'

function EventsList({ location }) {
  const { state } = location
  const { setUser, setAboutCurrentPage, setEditEvent, setOpenToast } = useContext(Context)

  const [fullEventsList, setFullEventsList] = useState([])
  const [eventsList, setEventsList] = useState([])
  const [filter, setFilter] = useState(0)
  const [tempList, setTempList] = useState([])
  const [isFiltered, setIsFiltered] = useState(false)
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [isLoading, setIsLoading] = useState(true)
  const [publicLoading, setPublicLoading] = useState({
    loading: false,
    objectId: 0
  })

  const [modalData, setModalData] = useState({
    title: '',
    id: 0
  })

  const checkLoading = id => {
    return publicLoading.loading && publicLoading.objectId === id
  }

  const updateEventsList = async () => {
    const response = await getEventsList()
    const eventsOrderByID = response.sort((a, b) => {
      if (a.id > b.id) {
        return -1
      }

      if (a.id < b.id) {
        return 1
      }
      return 0
    })

    return eventsOrderByID
  }

  useEffect(() => {
    if (searchData.startSearch) {
      setIsLoading(true)
      getSearch('events', searchData.str).then(r => {
        setEventsList(r)
        setSearchData({ ...searchData, startSearch: false })
        setIsLoading(false)
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setEventsList(fullEventsList)
    }

    // console.log('search', searchData);
  }, [searchData])

  const handlePublicClick = async id => {
    setPublicLoading({ loading: true, objectId: id })
    const itemToChange = eventsList.find(item => item.id === id)
    const situation = itemToChange.situation === 3 ? 1 : 3

    publishEvent(id, situation).then(r => {
      if (r && r.message === 'Atualizado com sucesso') {
        const newArr = eventsList.map(item => {
          return item.id === id ? { ...item, situation } : { ...item }
        })
        setEventsList([...newArr])
        setFullEventsList([...newArr])
        setPublicLoading({ loading: false, objectId: 0 })
        setOpenToast({
          open: true,
          message: `Evento ${situation === 3 ? `Desativado` : `Publicado`} com Sucesso.`,
          type: 'success'
        })
      } else {
        setOpenToast({
          open: true,
          message: `Ops... Ocorreu algum erro ao atualizar.`,
          type: 'error'
        })
      }
    })
  }

  const handleDeleteButton = async () => {
    setIsLoading(true)
    publishEvent(modalData.id, `2`).then(r => {
      if (r && r.message === 'Atualizado com sucesso') {
        const newArr = eventsList.filter(item => {
          return item.id !== modalData.id
        })
        setEventsList([...newArr])
        setFullEventsList([...newArr])
        setIsLoading(false)
        setOpenToast({
          open: true,
          message: 'Evento Deletado com Sucesso',
          type: 'success'
        })
      } else {
        setIsLoading(false)
        setOpenToast({
          open: true,
          message: 'Ops... Ocorreu algum erro ao Deletar',
          type: 'error'
        })
      }
    })
  }

  const handleEditButton = event => {
    setEditEvent({
      id: event.id,
      eventsWhiteLabels: event.EventsWhiteLabels || event.eventsWhiteLabels || []
    })
    history.push('eventform')
  }

  const handleSelectFilter = value => {
    const listToFilter = isFiltered ? tempList : fullEventsList
    let newList = []
    switch (value) {
      case '1':
        setFilter(1)
        newList = listToFilter.filter(item => {
          return item.situation === 1
        })
        setEventsList([...newList])
        break
      case '2':
        setFilter(3)
        newList = listToFilter.filter(item => {
          return item.situation === 3
        })
        setEventsList([...newList])
        break

      default:
        setFilter(0)
        setEventsList(listToFilter)
        break
    }
  }

  const handleSearch = str => {
    if (str.length >= 3) {
      setIsFiltered(true)
      const newList = fullEventsList.filter(item => {
        return !filter
          ? item.name.toLowerCase().includes(str.toLowerCase())
          : item.name.toLowerCase().includes(str.toLowerCase()) && item.situation === filter
      })
      setTempList(newList)
      setEventsList(newList)
    } else {
      setIsFiltered(false)
    }
    if (str.length === 0) {
      setIsFiltered(false)
      if (filter !== 0) {
        const newList = fullEventsList.filter(item => {
          return item.situation === filter
        })
        setTempList(newList)
        setEventsList(newList)
      } else {
        setTempList(fullEventsList)
        setEventsList(fullEventsList)
      }
    }
  }

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser())
    } else {
      history.replace('/')
    }
    setAboutCurrentPage({
      title: 'Eventos',
      buttons: [
        {
          title: 'Adicionar Evento',
          pathname: '/eventform'
        }
      ]
    })
    updateEventsList().then(r => {
      if (!r.message) {
        setFullEventsList([...r])
        setEventsList([...r])
      }
      setIsLoading(false)
    })

    setEditEvent({ id: null })

    if (state && state.showToast) {
      setOpenToast({
        open: true,
        message: state.toastMessage,
        type: 'success'
      })
    } else {
      setOpenToast({
        open: false,
        message: '',
        type: 'success'
      })
    }
  }, [])

  return (
    <div className="container-fluid">
      <Grid container xs={12} style={{ padding: 15 }}>
        <Grid item xs={12} justify="center">
          <ToastMessages />
          <Context.Provider value={{ searchData, setSearchData }}>
            <TopSearch
              // buttonLabel="Adicionar Evento"
              // goTo="/eventform"
              searchAction={handleSearch}
              showFilter
              filterAction={handleSelectFilter}
            />
          </Context.Provider>
        </Grid>
        <Grid item xs={12} justify="center">
          {isLoading ? (
            <LinearProgress marginTop="30px" marginBottom="10px" />
          ) : (
            <div className="row">
              {eventsList.length > 0 &&
                eventsList.map(event => (
                  <div key={event.id} className="col-3" style={{ padding: 10 }}>
                    <div className="card card-club h-100">
                      <img
                        className="card-img-top"
                        src={`${process.env.REACT_APP_IMAGES_URL}${event.cover}`}
                        alt={event.name}
                      />

                      <div className="card-body">
                        <h4
                          className="card-title w-100 d-flex justify-content-between align-content-center"
                          style={{ minHeight: 60 }}
                        >
                          {event.name}
                          {event.situation === 3 && (
                            <small style={{ fontSize: 12, color: 'red' }}>Rascunho</small>
                          )}
                          {event.situation === 1 && (
                            <small style={{ fontSize: 12, color: 'green' }}>Publicado</small>
                          )}
                        </h4>
                        {event.EventsProgrammings?.length && (
                          <>
                            {event.EventsProgrammings.map(item => (
                              <>
                                <br />
                                <span style={{ whiteSpace: 'nowrap' }}>
                                  {item.startDate === item.endDate
                                    ? item.startDate.split('-').reverse().join('/')
                                    : `${item.startDate
                                        .split('-')
                                        .reverse()
                                        .join('/')}-${item.endDate.split('-').reverse().join('/')}`}
                                </span>
                              </>
                            ))}
                          </>
                        )}
                      </div>
                      <div className="card-body d-flex align-content-center justify-content-between flex-grow-0">
                        <button
                          disabled={checkLoading(event.id)}
                          className={`btn ${event.situation === 3 ? 'btn-success' : 'btn-warning'}`}
                          onClick={() => handlePublicClick(event.id)}
                          type="button"
                        >
                          {event.situation === 3 ? 'Publicar' : 'Desativar'}
                        </button>

                        <button
                          className=" btn clube-btn clube-blue "
                          type="button"
                          onClick={() => handleEditButton(event)}
                        >
                          Editar
                        </button>
                        <button
                          className=" btn btn-danger "
                          type="button"
                          onClick={() =>
                            setModalData({
                              id: event.id,
                              title: event.name
                            })
                          }
                          data-toggle="modal"
                          data-target="#deleteModal"
                          style={{ marginLeft: -5 }}
                        >
                          <FaTrashAlt />
                        </button>
                      </div>
                      {checkLoading(event.id) && (
                        <LinearProgress marginBottom="10px" marginTop="10px" />
                      )}
                    </div>
                  </div>
                ))}
            </div>
          )}
        </Grid>
      </Grid>

      <div
        className="modal fade"
        id="deleteModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered " role="document">
          <div className="modal-content alert alert-danger">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Favor confirmar a exclusão do evento
                <strong>{modalData.title}</strong>
              </h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-danger"
                onClick={handleDeleteButton}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

EventsList.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    state: PropTypes.object
  }).isRequired
}

export default EventsList
